/* Cart bottle counter (snippets/press-cart-bottle.liquid), moved to an asset
   (CRO-22, 28 Oct 2026) so it is cached instead of inline on every page.
   Settings come from window.PCB_CFG (inline in the snippet); logic unchanged. */
(function () {
  var C = window.PCB_CFG;
  if (!C) return;
    var TARGET    = C.target;
    var SPEED     = C.speed;
    var POP       = C.pop;
    var SELECTOR  = C.selector;
    var COUNT_SEL = C.count_sel;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Surface position in bottle units. EMPTY sits below the glass so a
       sloshing crest cannot peek through; FULL is the shoulder, below the
       neck, which is where a real bottle stops. */
    var EMPTY = 12.2, FULL = 3.1;
    var WAVELEN = 2.4;
    var MAX_AMP = 0.42;

    /* Animation state. Kept outside any one bottle so a rebuilt header
       carries straight on. */
    var count = null;      /* last known item count */
    var level = 0;         /* 0..1, what is drawn right now */
    var from = 0, to = 0, start = 0, dur = 0;
    var amp = 0, ampPeak = 0, phase = 0;
    var raf = 0, lastT = 0;
    var pourAt = 0;        /* when the last add started, for handing over */
    /* 22 SEP 2026: the live theme's add animation. Every add fills the
       bottle right to the top with a wave, then it drains back down to the
       basket's level, about six seconds end to end. */
    var LIVE_FILL = C.live_fill;
    var after = null;      /* second leg of the live fill: level to settle at */

    var svgs = [];
    var countMo = null;
    var scheduled = false;

    function levelFor(n) { return TARGET > 0 ? Math.min(Math.max(n, 0) / TARGET, 1) : 0; }
    function easeInOut(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

    function surfacePath(a, ph) {
      if (a < 0.004) return 'M-0.5 0H7.06V14H-0.5Z';
      var d = 'M-0.5 ' + (a * Math.sin(ph - 0.5 * 2 * Math.PI / WAVELEN)).toFixed(3);
      for (var x = -0.25; x <= 7.06; x += 0.25) {
        d += 'L' + x.toFixed(2) + ' ' + (a * Math.sin(x * 2 * Math.PI / WAVELEN + ph)).toFixed(3);
      }
      return d + 'V14H-0.5Z';
    }

    function paintOne(svg) {
      var g = svg.querySelector('.pcb-liquid');
      var p = svg.querySelector('.pcb-juice');
      if (!g || !p) return;
      var y = EMPTY - level * (EMPTY - FULL);
      g.setAttribute('transform', 'translate(0 ' + y.toFixed(3) + ')');
      p.setAttribute('d', surfacePath(amp, phase));
    }
    function paint() { svgs.forEach(paintOne); }

    function frame(t) {
      var dt = lastT ? Math.min(t - lastT, 50) : 16;
      lastT = t;
      var k = dur > 0 ? Math.min((t - start) / dur, 1) : 1;
      level = from + (to - from) * easeInOut(k);

      /* The slosh builds quickly as the pour starts, then dies away, and
         runs a little past the end of the level change so it settles
         rather than stopping dead. */
      var sk = dur > 0 ? Math.min((t - start) / (dur * 1.35), 1) : 1;
      amp = ampPeak * Math.min(sk * 7, 1) * Math.pow(1 - sk, 1.6);
      phase += dt * 0.011;

      paint();
      if (k >= 1 && after !== null) {
        /* top reached: drain back down to the real level, still sloshing */
        from = level; to = after; after = null;
        start = t; dur = Math.round(SPEED * 3.2); ampPeak = MAX_AMP * 0.8;
        raf = requestAnimationFrame(frame); return;
      }
      if (sk < 1) { raf = requestAnimationFrame(frame); }
      else { raf = 0; lastT = 0; amp = 0; level = to; paint(); }
    }

    function restartClass(svg, cls) {
      svg.classList.remove(cls);
      void svg.getBoundingClientRect();
      svg.classList.add(cls);
    }

    function goTo(n) {
      n = Math.max(0, n | 0);
      if (count === null) { count = n; level = to = levelFor(n); paint(); label(); return; }
      if (n === count) return;
      var grew = n > count;
      count = n;
      label();

      from = level;
      to = levelFor(n);
      after = null;

      if (reduced) { level = to; amp = 0; paint(); return; }

      dur = grew ? SPEED : Math.round(SPEED * 0.7);
      if (grew && LIVE_FILL && to < 1) { after = to; to = 1; dur = Math.round(SPEED * 2); }
      /* Already full: no level change, but still slosh and pop so the add
         is acknowledged. */
      ampPeak = grew ? MAX_AMP : MAX_AMP * 0.55;
      start = performance.now();

      if (grew) {
        pourAt = start;
        svgs.forEach(function (s) {
          s.style.setProperty('--pcb-offset', '0ms');
          restartClass(s, 'is-pouring');
          if (POP) restartClass(s, 'is-popping');
        });
      }
      if (!raf) raf = requestAnimationFrame(frame);
    }

    function label() {
      svgs.forEach(function (svg) {
        var host = svg.closest('.pcb-host');
        if (host && count !== null) host.setAttribute('aria-label', count === 1 ? '1 item in your cart' : count + ' items in your cart');
      });
    }

    function readCount() {
      var el = document.querySelector(COUNT_SEL);
      if (!el) return 0;
      var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
      return isNaN(n) ? 0 : n;
    }

    var fetchSeq = 0;
    function fetchCount() {
      var seq = ++fetchSeq;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (seq === fetchSeq && c && typeof c.item_count === 'number') goTo(c.item_count); })
        .catch(function () {});
    }

    function build(link) {
      if (link.dataset.pcb === '1') {
        var existing = link.querySelector('.pcb-bottle');
        if (existing) return existing;
      }
      link.dataset.pcb = '1';
      link.classList.add('pcb-host');
      [].slice.call(link.querySelectorAll('svg, img')).forEach(function (n) {
        if (!n.classList.contains('pcb-bottle')) n.classList.add('pcb-hidden');
      });
      var slot = link.querySelector('.cart-link__icon') || link;
      var tpl = document.getElementById('pcb-template');
      if (!tpl) return null;
      var svg = tpl.content.firstElementChild.cloneNode(true);
      var uid = 'pcb-' + Math.random().toString(36).slice(2, 8);
      svg.querySelector('clipPath').id = uid;
      svg.querySelector('[clip-path]').setAttribute('clip-path', 'url(#' + uid + ')');
      slot.insertBefore(svg, slot.firstChild);
      /* Draw the current frame straight away, so a bottle that replaces one
         mid pour continues from where the old one was. */
      paintOne(svg);
      /* Deacon swaps the header a few hundred ms into an add. Pick up the
         pop and the bubbles part way through instead of losing them. */
      var since = pourAt ? performance.now() - pourAt : 1e9;
      if (!reduced && since < 900) {
        svg.style.setProperty('--pcb-offset', '-' + Math.round(since) + 'ms');
        svg.classList.add('is-pouring');
        if (POP) svg.classList.add('is-popping');
      }
      return svg;
    }

    function wire() {
      /* Only the header cart icon. The drawer's Checkout button also links to
         /cart (it sends people to the cart page for the delivery date), and
         must never be turned into a bottle. */
      var links = [].slice.call(document.querySelectorAll(SELECTOR))
        .filter(function (l) {
          return document.contains(l) &&
            !l.classList.contains('button') &&
            !(l.closest && l.closest('.checkout-buttons, cart-drawer, .cart-drawer, [data-merge-attributes="checkout-buttons"], #cart-drawer, .pcart-section'));
        });
      if (!links.length) return;
      if (countMo) { try { countMo.disconnect(); } catch (e) {} countMo = null; }

      svgs = links.map(build).filter(Boolean);
      if (!svgs.length) return;

      goTo(readCount());
      label();

      /* The header count is a second source, for any cart change that does
         not announce itself. */
      var hosts = links.map(function (l) { return l.querySelector('.cart-link__icon') || l; });
      countMo = new MutationObserver(function () { goTo(readCount()); });
      hosts.forEach(function (h) {
        countMo.observe(h, { childList: true, characterData: true, subtree: true });
      });
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; wire(); });
    }

    function watchHeader() {
      var target = document.querySelector('#pageheader') || document.body;
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var el = added[j];
            if (!el || el.nodeType !== 1 || !el.querySelector) continue;
            if ((el.matches && el.matches(SELECTOR)) || el.querySelector(SELECTOR)) { schedule(); return; }
          }
        }
      }).observe(target, { childList: true, subtree: true });
    }

    /* ------------------------------------------------------------------
       Cart event bridge

       Deacon refreshes the drawer and header on theme:cartchanged only.
       Some custom sections announce adds with cart:refresh, cart:build or
       ajaxProduct:added instead, and those are translated here. Others
       fire theme:cartchanged AND cart:refresh, which used to produce a
       second refresh of the drawer and header on every add. Any
       theme:cartchanged in the last 600ms now suppresses the bridge.
       ------------------------------------------------------------------ */
    var lastCartEvent = 0;
    window.addEventListener('theme:cartchanged', function () { lastCartEvent = Date.now(); }, true);

    /* 22 SEP 2026, as on the old site: the cart drawer opens by itself only
       when the first item goes into an empty basket. After that an add plays
       the bottle animation and the drawer stays shut, so shoppers can keep
       adding. Every add path in the theme announces itself with this event
       and asks for the drawer through detail.openDrawer, and this listener
       runs first (capture, on window), so it decides for all of them. */
    var DRAWER_FIRST_ONLY = C.drawer_first_only;
    var itemsBefore = C.items;
    var itemsSeq = 0;
    window.addEventListener('theme:cartchanged', function (e) {
      if (!DRAWER_FIRST_ONLY) return;
      var d = e.detail;
      if (d && d.openDrawer && itemsBefore > 0) d.openDrawer = false;
      var seq = ++itemsSeq;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (seq === itemsSeq && c && typeof c.item_count === 'number') itemsBefore = c.item_count; })
        .catch(function () {});
    }, true);
    /* A basket emptied from the drawer or the cart page counts as empty
       again. Those changes do not announce themselves, so the cart's own
       change, update and clear responses are read as they come back. */
    if (window.fetch && !window.__pcbFetchWrapped) {
      window.__pcbFetchWrapped = true;
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = nativeFetch.apply(this, arguments);
        if (/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) {
          p.then(function (r) {
            r.clone().json().then(function (c) {
              if (c && typeof c.item_count === 'number') itemsBefore = c.item_count;
            }).catch(function () {});
          }).catch(function () {});
        }
        return p;
      };
    }


    function bridgeCartEvent() {
      if (Date.now() - lastCartEvent < 600) return;
      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
        bubbles: true, cancelable: false, detail: { openDrawer: true }
      }));
    }

    function init() {
      ['cart:refresh', 'cart:build', 'ajaxProduct:added'].forEach(function (name) {
        document.addEventListener(name, bridgeCartEvent);
      });

      wire();
      watchHeader();

      document.addEventListener('theme:cartchanged', function () {
        fetchCount();
        /* In case the header lands late or not at all. */
        setTimeout(function () { wire(); }, 900);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
    document.addEventListener('shopify:section:load', schedule);
  })();